import { createAction } from 'redux-actions';
import {
    SET_OPTION,
    SET_OPTIONLOADING
} from '../constants/actionTypes';
import { doGet, doPost } from '../utils/AjaxRequests'
import _ from 'lodash'
import { apiPrefixUrl } from '../utils/connection'
import { format, parse, isValid } from 'date-fns'
import { weeks } from '../utils/utils'
import { setFormValue } from './formAction';

export const setOption = createAction(SET_OPTION)
export const setOptionLoading = createAction(SET_OPTIONLOADING)

export const fetchInitialOptions = () => {
    return (dispatch) => {
        doPost(apiPrefixUrl, {
            api: 'TWZip'
        })
            .then((data) => {
                let cityOptions = _.map(data.data, (item, key) => ({ value: item.City, label: item.City }))
                dispatch(setOption({ field: 'city', options: cityOptions }))
            })


        doPost(apiPrefixUrl, {
            "api": "ConfigVACC",
            "SPNO": "",
            "USER_ID": "PATIENT"
        })
            .then((data) => {
                let configOptions = _.map(_.filter(data.data, item => item.IsValied === "Y"), (item, key) => ({ value: item.VaccID, label: item.Name }))
                dispatch(setOption({ field: 'config', options: configOptions }))
            })

    }

}


export const getConformType = () => {
    return (dispatch, getState) => {
        dispatch(setOption({ field: 'conform', options: [] }))
        doPost(apiPrefixUrl, {
            "api": "ConfigVACC",
            "SPNO": "",
            "USER_ID": "PATIENT"
        })
            .then((data) => {
                let vaccID = getState().getIn(["form", "VACC_ID"])
                let VaccInfo = _.find(data.data, (o) => (o.VaccID === vaccID))
                if (VaccInfo) {
                    let conformOptions = VaccInfo.ConformTypes
                    conformOptions = _.map(_.filter(conformOptions, item=>item.IsValied === "Y"), (item, key) => ({ value: item.ConformType, label: item.Name }))
                    dispatch(setOption({ field: 'conform', options: conformOptions }))
                    if ((_.filter(conformOptions, (o) => o.value === getState().getIn(["form", "conformId"]))).length === 0) {
                        dispatch(setFormValue({ field: "conformId", value: "" }))
                    }
                }

            })
    }
}


export const getReserveDate = () => {

    return (dispatch, getState) => {


        const conformId = getState().getIn(["form", "conformId"])
        const DOSAGE_COUNT = getState().getIn(["form", "DOSAGE_COUNT"])
        const PRE_VACCINE_DATE = getState().getIn(["form", "PRE_VACCINE_DATE"])
        const VACC_ID = getState().getIn(["form", "VACC_ID"])

        dispatch(setOption({ field: 'reserveDate', options: [] }))

        if (DOSAGE_COUNT) {
            dispatch(setOptionLoading({ loading: true }))
            doPost(apiPrefixUrl, {
                "api": "SchdsetsVACC",
                "SPNO": "",
                "USER_ID": "PATIENT",
                "VACC_ID": VACC_ID,
                "CONFORM_TYPE": conformId,
                "DOSAGE_COUNT": DOSAGE_COUNT,
                "PRE_VACCINE_DATE": PRE_VACCINE_DATE || "",
                "REG_DATE": ""
            })
                .then((data) => {
                    if (data.status) {
                        let dateOptions = _.map(_.uniqBy(data.data, 'START_DATE'), (item, key) => {
                            return {
                                value: item.START_DATE,
                                label: `${item.START_DATE_STR} (${weeks[item.DAYS_STR]})`
                            }
                        })
                        dispatch(setOption({ field: 'reserveDate', options: dateOptions }))
                    }
                })
            dispatch(setOptionLoading({ loading: false }))
        }
    }
}


export const getReserveTime = () => {
    return (dispatch, getState) => {


        const conformId = getState().getIn(["form", "conformId"])
        const DOSAGE_COUNT = getState().getIn(["form", "DOSAGE_COUNT"])
        const PRE_VACCINE_DATE = getState().getIn(["form", "PRE_VACCINE_DATE"])
        const VACC_ID = getState().getIn(["form", "VACC_ID"])
        const reserveDate = getState().getIn(["form", "reserveDate"])

        dispatch(setOption({ field: 'reserveTime', options: [] }))


        dispatch(setOptionLoading({ loading: true }))

        if (!reserveDate) {
            dispatch(setOption({ field: 'reserveTime', options: [] }))
        } else {
            doPost(apiPrefixUrl, {
                "api": "SchdsetsVACC",
                "SPNO": "",
                "USER_ID": "PATIENT",
                "VACC_ID": VACC_ID,
                "CONFORM_TYPE": conformId,
                "DOSAGE_COUNT": DOSAGE_COUNT,
                "PRE_VACCINE_DATE": PRE_VACCINE_DATE || "",
                "REG_DATE": reserveDate
            })
                .then((data) => {
                    if (data.status) {
                        let dateOptions = _.map(data.data, (item, key) => {
                            let dateStr = `${item.START_DATE_STR} (${weeks[item.DAYS_STR]})`
                            let timeStr = item.START_TIME_STR
                            let isFull = parseInt(item.TOT_LIMIT) <= parseInt(item.APPOINTMENT_CNT)

                            return {
                                value: item.SCHD_ID,
                                label: `${dateStr} ${timeStr}${isFull ? `(滿)` : ""}-剩餘${item.TOT_LIMIT - item.APPOINTMENT_CNT}人`,
                                token: item.TOKEN,
                                disabled: isFull
                            }
                        })
                        dispatch(setOption({ field: 'reserveTime', options: dateOptions }))

                    }
                })
        }



        dispatch(setOptionLoading({ loading: false }))
    }
}


export const getAreaCode = () => {
    return (dispatch, getState) => {
        const city = getState().getIn(["form", "city"])
        dispatch(setOption({ field: 'AREA_CODE', options: [] }))
        if (city) {
            doPost(apiPrefixUrl, {
                api: 'TWZip'
            })
                .then((data) => {
                    let cityArea = _.find(data.data, (o) => (o.City === city))
                    let areaCodeOptions = _.map(cityArea.Citys, (item, key) => ({ label: item.District, value: item.ZipCode }))
                    dispatch(setOption({ field: 'AREA_CODE', options: areaCodeOptions }))
                })
        }
    }
}

